import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { experiencesUpdateEvent, ServiceEventResource } from '~/generated';
import { extractData } from '~/utils/query-utils';

type UpdateEventParams = {
  experienceId: number;
  eventId: number;
  body: ServiceEventResource;
};

export const useUpdateEvent = (
  options: UseMutationOptions<
    ServiceEventResource,
    unknown,
    UpdateEventParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateEventParams) =>
      extractData(
        experiencesUpdateEvent({
          path: { experienceId: data.experienceId, eventId: data.eventId },
          body: data.body,
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['Experiences'],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
